import type { CSSProperties } from 'react'

/**
 * Computes a fixed position for a popover anchored below a given rect,
 * flipping above if there isn't enough viewport space below.
 */
export function computePopoverPosition(
  anchorRect: DOMRect,
  popoverHeight: number = 200,
): CSSProperties {
  // Phone: there is no room beside a word, so the popover docks to the bottom edge at
  // full width. `useSheetAnchor` then lifts the tapped word clear of it.
  if (window.innerWidth < 640) {
    return { top: 'auto', bottom: 0, left: 0, right: 0, visibility: 'visible' }
  }

  const popoverWidth = 320
  const gap = 8
  const viewportPadding = 16

  let top = anchorRect.bottom + gap
  let left = anchorRect.left + anchorRect.width / 2 - popoverWidth / 2

  if (left < viewportPadding) left = viewportPadding
  if (left + popoverWidth > window.innerWidth - viewportPadding) {
    left = window.innerWidth - viewportPadding - popoverWidth
  }

  if (top + popoverHeight > window.innerHeight - viewportPadding) {
    top = anchorRect.top - gap - popoverHeight
    if (top < viewportPadding) top = viewportPadding
  }

  return { top, left, visibility: 'visible' }
}
